export const limitedService = {

    isLimitedCode(code) {
        let limited = ['birth-noncertified-adopted','birth-homeless', 'birth-va', 'death-va', 'amend-birth']
        return limited.includes(code)
    },
    isLimited(category, code) {
        const limitedCategory = ['DATA', 'MFAR']
        const limitedProduct = ['BIRTH_NONCERTIFIED_ADOPTED','BIRTH_HOMELESS', 'BIRTH_VA', 'DEATH_VA']
        const isCategory = limitedCategory.findIndex(i => i === category) > -1
        const isProduct = limitedProduct.findIndex(i => i === code ) > -1
        return isCategory || isProduct
    },
}